var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2226_236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2226_236",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6748 4.3502C3.6748 3.30085 4.52546 2.4502 5.5748 2.4502L43.4248 2.4502C44.4741 2.4502 45.3248 3.30086 45.3248 4.3502V26.7052C45.3248 37.6653 35.6065 46.5502 24.4998 46.5502C13.3931 46.5502 3.6748 37.6653 3.6748 26.7052V4.3502Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.6748 4.3502C3.6748 3.30085 4.52546 2.4502 5.5748 2.4502L43.4248 2.4502C44.4741 2.4502 45.3248 3.30086 45.3248 4.3502V26.7052C45.3248 37.6653 35.6065 46.5502 24.4998 46.5502C13.3931 46.5502 3.6748 37.6653 3.6748 26.7052V4.3502Z",
    fill: "url(#paint0_linear_2226_236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3248 4.3502V26.7052H47.3248V4.3502H43.3248ZM5.6748 26.7052V4.3502H1.6748V26.7052H5.6748ZM24.4998 44.5502C14.3806 44.5502 5.6748 36.4472 5.6748 26.7052H1.6748C1.6748 38.8834 12.4057 48.5502 24.4998 48.5502V44.5502ZM43.3248 26.7052C43.3248 36.4472 34.619 44.5502 24.4998 44.5502V48.5502C36.594 48.5502 47.3248 38.8834 47.3248 26.7052H43.3248ZM5.5748 4.4502L43.4248 4.4502V0.450197L5.5748 0.450195L5.5748 4.4502ZM5.6748 4.3502C5.6748 4.40542 5.63003 4.4502 5.5748 4.4502L5.5748 0.450195C3.42089 0.450195 1.6748 2.19628 1.6748 4.3502H5.6748ZM47.3248 4.3502C47.3248 2.19629 45.5787 0.450197 43.4248 0.450197V4.4502C43.3696 4.4502 43.3248 4.40542 43.3248 4.3502H47.3248Z",
    fill: "white",
    fillOpacity: 0.4,
    mask: "url(#path-1-inside-1_2226_236)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_angular_2226_236_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.003 -0.003 0 25 24.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1333.33,
    y: -1333.33,
    width: 2666.67,
    height: 2666.67
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(224, 224, 224, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.6844C24.8243 21.4385 25.1757 21.4385 25.3024 21.6844L26.1074 23.2461C26.1398 23.309 26.191 23.3602 26.2539 23.3926L27.8156 24.1976C28.0615 24.3243 28.0615 24.6757 27.8156 24.8024L26.2539 25.6074C26.191 25.6398 26.1398 25.691 26.1074 25.7539L25.3024 27.3156C25.1757 27.5615 24.8243 27.5615 24.6976 27.3156L23.8926 25.7539C23.8602 25.691 23.809 25.6398 23.7461 25.6074L22.1844 24.8024C21.9385 24.6757 21.9385 24.3243 22.1844 24.1976L23.7461 23.3926C23.809 23.3602 23.8602 23.309 23.8926 23.2461L24.6976 21.6844Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87999999523162842,\"g\":0.87999999523162842,\"b\":0.87999999523162842,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87999999523162842,\"g\":0.87999999523162842,\"b\":0.87999999523162842,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":3.6739405577555036e-16,\"m01\":-6.0,\"m02\":28.0,\"m10\":6.0,\"m11\":3.6739405577555036e-16,\"m12\":21.50},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_angular_2226_236_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.003 0 0 -0.003 25 24.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1333.33,
    y: -1333.33,
    width: 2666.67,
    height: 2666.67
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(224, 224, 224, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 0.5
    }
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.6844C24.8243 21.4385 25.1757 21.4385 25.3024 21.6844L26.1074 23.2461C26.1398 23.309 26.191 23.3602 26.2539 23.3926L27.8156 24.1976C28.0615 24.3243 28.0615 24.6757 27.8156 24.8024L26.2539 25.6074C26.191 25.6398 26.1398 25.691 26.1074 25.7539L25.3024 27.3156C25.1757 27.5615 24.8243 27.5615 24.6976 27.3156L23.8926 25.7539C23.8602 25.691 23.809 25.6398 23.7461 25.6074L22.1844 24.8024C21.9385 24.6757 21.9385 24.3243 22.1844 24.1976L23.7461 23.3926C23.809 23.3602 23.8602 23.309 23.8926 23.2461L24.6976 21.6844Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87843137979507446,\"g\":0.87843137979507446,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87843137979507446,\"g\":0.87843137979507446,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-6.0,\"m01\":-6.3918976448557041e-13,\"m02\":28.0,\"m10\":-2.8473786371253917e-13,\"m11\":-6.0,\"m12\":27.50},\"opacity\":0.50,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7469 21.4553C25.434 20.8482 24.566 20.8482 24.2531 21.4553L23.4716 22.9716L21.9553 23.7531C21.3482 24.066 21.3482 24.934 21.9553 25.2469L23.4716 26.0284L24.2531 27.5447C24.566 28.1518 25.434 28.1518 25.7469 27.5447L26.5284 26.0284L28.0447 25.2469C28.6518 24.934 28.6518 24.066 28.0447 23.7531L26.5284 22.9716L25.7469 21.4553Z",
    stroke: "black",
    strokeOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01025 33.5957L36.1558 2.4502H43.4256C44.4749 2.4502 45.3256 3.30085 45.3256 4.3502V14.0694L15.0746 44.3204C10.5269 42.0588 6.86907 38.2361 5.01025 33.5957Z",
    fill: "white",
    fillOpacity: 0.32
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2226_236",
    x: 3.6748,
    y: 2.4502,
    width: 41.6499,
    height: 45.0496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.24 0 0 0 0 0.118652 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2226_236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2226_236",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_angular_2226_236_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.6844C24.8243 21.4385 25.1757 21.4385 25.3024 21.6844L26.1074 23.2461C26.1398 23.309 26.191 23.3602 26.2539 23.3926L27.8156 24.1976C28.0615 24.3243 28.0615 24.6757 27.8156 24.8024L26.2539 25.6074C26.191 25.6398 26.1398 25.691 26.1074 25.7539L25.3024 27.3156C25.1757 27.5615 24.8243 27.5615 24.6976 27.3156L23.8926 25.7539C23.8602 25.691 23.809 25.6398 23.7461 25.6074L22.1844 24.8024C21.9385 24.6757 21.9385 24.3243 22.1844 24.1976L23.7461 23.3926C23.809 23.3602 23.8602 23.309 23.8926 23.2461L24.6976 21.6844Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_angular_2226_236_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.6844C24.8243 21.4385 25.1757 21.4385 25.3024 21.6844L26.1074 23.2461C26.1398 23.309 26.191 23.3602 26.2539 23.3926L27.8156 24.1976C28.0615 24.3243 28.0615 24.6757 27.8156 24.8024L26.2539 25.6074C26.191 25.6398 26.1398 25.691 26.1074 25.7539L25.3024 27.3156C25.1757 27.5615 24.8243 27.5615 24.6976 27.3156L23.8926 25.7539C23.8602 25.691 23.809 25.6398 23.7461 25.6074L22.1844 24.8024C21.9385 24.6757 21.9385 24.3243 22.1844 24.1976L23.7461 23.3926C23.809 23.3602 23.8602 23.309 23.8926 23.2461L24.6976 21.6844Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2226_236",
    x1: 24.4996,
    y1: 55.4451,
    x2: 24.4996,
    y2: 3.00147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A66E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop3);
export default __webpack_public_path__ + "static/media/top3.933c97c45a4b4c58557b96ec1ffe7027.svg";
export { ForwardRef as ReactComponent };